// extracted by mini-css-extract-plugin
export default {"tab":"tab_tab__AXNqj","tab_active":"tab_tab_active__XMrxh"};